import { hasFeature } from 'features/helpers';
import { FEATURES } from 'features/features';
import { LOCATION_HISTORY_SOURCE } from 'constants/globalConstants';

export const FILTERS = {
  allTypes:
    'garage_agree,check_auto_express,sanlam_agencies,depositPoints,clinics',
  approvedGarages: 'garage_agree',
  checkAutoExpress: 'check_auto_express',
  agentSA: 'saham_agencies',
  doctors: 'directory_of_doctors',
  depositPoints: 'point_de_depot',
  clinics: 'reseau_national',
};

export const FILTER_WITH_FROM_SOURCE: any = {
  [LOCATION_HISTORY_SOURCE.findAgent]: FILTERS.depositPoints,
  [LOCATION_HISTORY_SOURCE.directoryOfDoctors]: FILTERS.doctors,
};

export const FILTERS_BY_UNIVERSE: any = {
  AUTO: ['approvedGarages', 'checkAutoExpress', 'agentSA'],
  SANTE: ['doctors', 'depositPoints', 'clinics'],
};

export const CASABLANCA = {
  lat: 33.58831,
  lon: -7.61138,
  name: 'Casablanca',
};

export const DELTA = 0.1;

export const UNIVERSES = () => [
  { label: 'auto', value: 'AUTO', isVisible: true },
  {
    label: 'amc',
    value: 'SANTE',
    isVisible: hasFeature(FEATURES.UNIVERSE_AMC),
  },
];
